import { render, staticRenderFns } from "./AvailableCompanies.vue?vue&type=template&id=18a774e3"
import script from "./AvailableCompanies.vue?vue&type=script&lang=js"
export * from "./AvailableCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a774e3')) {
      api.createRecord('18a774e3', component.options)
    } else {
      api.reload('18a774e3', component.options)
    }
    module.hot.accept("./AvailableCompanies.vue?vue&type=template&id=18a774e3", function () {
      api.rerender('18a774e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/industry/AvailableCompanies.vue"
export default component.exports